module.exports = __webpack_public_path__ + "platinium.jpg?18b148cc794b4bdff7ebac86f2ead571";


//////////////////
// WEBPACK FOOTER
// ./statics/img/platinium.jpg
// module id = 143
// module chunks = 20